"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolPicker = void 0;
var mithril_1 = require("../../mithril");
var theme_1 = require("../theme");
var CSS = {
    container: 'c-ToolPicker'
};
var Style = (_a = {},
    _a[CSS.container] = {
        display: 'flex',
        flexDirection: 'column',
        padding: '6px'
    },
    _a);
(0, theme_1.addStyles)(Style);
exports.ToolPicker = {
    view: function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.children, children = _c === void 0 ? [] : _c, _d = _b.className, className = _d === void 0 ? '' : _d;
        return (0, mithril_1.m)('div', {
            className: "".concat(CSS.container, " ").concat(className)
        }, children);
    }
};
//# sourceMappingURL=tool.picker.js.map